import React from "react";
import moment from "moment";

const OurDate = props => {
  if (!props.value) {
    return null;
  }

  return <span>{moment(props.value).format("DD.MM.YYYY")}</span>;
};

export default OurDate;
